export default "__VITE_ASSET__CI1BrhNH__"